import { useContext } from 'react'

import { AuthUserContext } from '../components/root/router'

export const getAuthUser = () => useContext(AuthUserContext)
